/* eslint-disable no-redeclare */
<template>
	<div class="filters p-0 flex">
		<div class="box">
			<el-card class="card">
				<div class="bottomBox">
					<div class="recordTable">
						<el-table :data="recordData" class="wid100">
							<!-- 序号 -->
							<el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')"
								width="100px">
							</el-table-column>
							<el-table-column prop="parkId" :label="$t('lang.lab_ownerName')">
								<template slot-scope="scope">{{scope.row.roomOwner}}
								</template>
							</el-table-column>
							<!-- 车牌号 -->
							<el-table-column prop="carNum" :label="$t('lang.lab_carNumber')">
							</el-table-column>
							<!-- 入场时间 -->
							<el-table-column prop="inTime" :label="$t('lang.lab_InTime')">
								<template slot-scope="scope">{{scope.row.inTime | time}}</template>
							</el-table-column>
							<!-- 出场时间 -->
							<el-table-column prop="outTime" :label="$t('lang.lab_OutTime')">
								<template slot-scope="scope">{{scope.row.outTime | time}}</template>
							</el-table-column>
							<!-- 停车时长 -->
							<el-table-column prop="inOutDeff" :label="$t('lang.lab_inOutDeff')">
								<template slot-scope="scope">{{scope.row.inOutDeff | formatInOutDeff}}</template>
							</el-table-column>
							<el-table-column prop="state" :label="$t('lang.resourStatus')" width="100">
								<template slot-scope="scope">
									<span v-if="scope.row.state === 1">{{$t('lang.lab_In')}}</span>
									<span v-if="scope.row.state === 2">{{$t('lang.lab_Out')}}</span>
								</template>
							</el-table-column>

						</el-table>
					</div>
				</div>
			</el-card>
			<div class="carIn" @click="peopleIn">
				<img class="cardImg" src="../../../assets/imgs/icon_carIn.png" />
			</div>
		</div>
		<div class="box">
			<el-card class="card">
				<div class="bottomBox">
					<div class="recordTable">
						<el-table :data="errorRecordData" class="wid100">
							<!-- 序号 -->
							<el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')"
								width="100px">
							</el-table-column>
							<!-- 车场名称 -->
							<el-table-column prop="parkId" :label="$t('lang.lab_parkName')">
								<template slot-scope="scope" v-if="scope&&scope.row.carPark">{{scope.row.carPark.parkName}}</template>
							</el-table-column>
							<!-- 摄像头编号  -->
							<el-table-column prop="cameraNum" :label="$t('lang.lab_cameraNum')">
								<template slot-scope="scope" v-if="scope&&scope.row.cameraNum">{{scope.row.cameraNum}}</template>
							</el-table-column>
							<!-- 车牌号 -->
							<el-table-column prop="carNum" :label="$t('lang.lab_carNumber')"></el-table-column>
							<!-- 出入口类型 -->
							<el-table-column prop="gateType" :label="$t('lang.lab_gateType')">
								<template slot-scope="scope">
									<span v-if="scope.row.gateType === 1">{{$t('lang.lab_gateEntry')}}</span>
									<span v-if="scope.row.gateType === 2">{{$t('lang.lab_gateExit')}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="gateName" :label="$t('lang.lab_gateName')">
								<template slot-scope="scope" v-if="scope&&scope.row.carGate">{{scope.row.carGate.gateName}}</template>
							</el-table-column>
							<!-- 操作时间 -->
							<el-table-column prop="createTime" :label="$t('lang.lab_otDoorDeviceSon')">
								<template slot-scope="scope">{{scope.row.createTime | time}}</template>
							</el-table-column>
							<!-- 状态 -->
							<el-table-column prop="errorCode" :label="$t('lang.resourStatus')">
								<template slot-scope="scope">
									<span v-if="scope.row.errorCode === 0">{{$t('lang.lab_errorCode0')}}</span>
									<span v-if="scope.row.errorCode === 2">{{$t('lang.lab_errorCode2')}}</span>
									<span v-if="scope.row.errorCode === 3">{{$t('lang.lab_errorCode3')}}</span>
									<span v-if="scope.row.errorCode === 4">{{$t('lang.lab_errorCode4')}}</span>
									<span v-if="scope.row.errorCode === 5">{{$t('lang.lab_errorCode5')}}</span>
									<span v-if="scope.row.errorCode === 6">{{$t('lang.lab_errorCode6')}}</span>
									<span v-if="scope.row.errorCode === 7">{{$t('lang.lab_errorCode7')}}</span>
									<span v-if="scope.row.errorCode === 8">{{$t('lang.lab_errorCode8')}}</span>
									<span v-if="scope.row.errorCode === 9">{{$t('lang.lab_errorCode9')}}</span>
									<span v-if="scope.row.errorCode === 10">{{$t('lang.lab_errorCode10')}}</span>
									<span v-if="scope.row.errorCode === 11">{{$t('lang.lab_errorCode11')}}</span>
									<span v-if="scope.row.errorCode === 12">{{$t('lang.lab_errorCode12')}}</span>
									<span v-if="scope.row.errorCode === 13">{{$t('lang.lab_errorCode13')}}</span>
									<span v-if="scope.row.errorCode === 14">{{$t('lang.lab_errorCode14')}}</span>
									<span v-if="scope.row.errorCode === 15">{{$t('lang.lab_errorCode15')}}</span>
									<span v-if="scope.row.errorCode === 16">{{$t('lang.lab_errorCode16')}}</span>
									<span v-if="scope.row.errorCode === 17">{{$t('lang.lab_errorCode17')}}</span>
									<span v-if="scope.row.errorCode === 18">{{$t('lang.lab_errorCode18')}}</span>
								</template>
							</el-table-column>
							<!-- 照片 -->
							<el-table-column prop="imagePath" :label="$t('lang.lab_picture')" width="100">
								<template slot-scope="scope">
									<a @click="seePhoto(scope.row.imagePath)">查看照片</a>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</el-card>
			<div class="carOut" @click="peopleOut">
				<img class="cardImg" src="../../../assets/imgs/icon_carOut.png" />
			</div>
		</div>
		<el-dialog :title="inOut==1?$t('lang.lab_peoIn'):$t('lang.lab_peoOut')" :visible.sync="dialogVisible"
			:close-on-click-modal="false" center top="130px" width="600px">
			<el-form ref="form" :model="form" :rules="rule" label-width="80px">
				<el-form-item :label="$t('lang.lab_carNumber')" prop="carNum">
					<el-input v-model="form.carNum" :placeholder="$t('lang.lab_writeCarNum')"></el-input>
					<el-button type="primary" @click="onSdkz(form)">{{$t('lang.lab_sdkz')}}</el-button>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_gate')" prop="gateId">
					<el-select v-model="form.gateId" :placeholder="$t('lang.lab_checkGate')">
						<el-option v-for="(item,index) in carGateData" :key="index" :label="item.gateName" :value="item.id">
						</el-option>
					</el-select>					
					<el-button type="primary" @click="onSscph(form)">获取实时车牌号</el-button>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_remark')" prop="remark">
					<el-input type="textarea" v-model="form.remark" :placeholder="$t('lang.lab_writeRemark')">
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSubmit(form)">{{$t('lang.btn_confirm')}}</el-button>
					<el-button @click="hideDialog">{{$t('lang.btn_cancel')}}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="车辆照片" :visible.sync="dialogVisible1" width="50%">
			<el-image :src="imgUrl" :preview-src-list="imgUrlList">
			</el-image>
		</el-dialog>
	</div>
</template>

<script>
	import '../../../config/ezuikit.js'
	export default {
		filters: {
			formatInOutDeff(value) {
				var theTime = parseInt(value) // 需要转换的时间秒 
				var theTime1 = 0 // 分 
				var theTime2 = 0 // 小时 
				var theTime3 = 0 // 天
				if (theTime > 60) {
					theTime1 = parseInt(theTime / 60)
					theTime = parseInt(theTime % 60)
					if (theTime1 > 60) {
						theTime2 = parseInt(theTime1 / 60)
						theTime1 = parseInt(theTime1 % 60)
						if (theTime2 > 24) {
							// 大于24小时
							theTime3 = parseInt(theTime2 / 24)
							theTime2 = parseInt(theTime2 % 24)
						}
					}
				}
				var result = ''
				if (theTime > 0) {
					result = '' + parseInt(theTime) + '秒'
				}
				if (theTime1 > 0) {
					result = '' + parseInt(theTime1) + '分' + result
				}
				if (theTime2 > 0) {
					result = '' + parseInt(theTime2) + '小时' + result
				}
				if (theTime3 > 0) {
					result = '' + parseInt(theTime3) + '天' + result
				}
				return result
			}
		},
		data() {
			return {
				inOut: '', // 人工入场(1)&人工出场(2)
				gardenId: '', // 小区id
				parkId: '', // 车场ID
				dialogVisible: false,
				recordData: [], // 记录数据
				errorRecordData: [], // 错误日志数据
				carGateData: [], // 弹窗出入口数据
				dialogVisible1: false, // 查看车辆照片弹窗
				imgUrl: '', // 车辆照片url
				imgUrlList: [], // 车辆照片预览大图url
				form: {
					carNum: '',
					gateId: '',
					remark: '',
				},
				rule: {
					carNum: [{
						required: true,
						message: this.$i18n.t('lang.lab_pleRightCarNum'),
						trigger: 'blur',
						pattern: /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DABCEFGHJK]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DABCEFGHJK]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
					}],
					gateId: [{
						required: true,
						message: this.$i18n.t('lang.lab_checkGate'),
						trigger: 'change'
					}],
				},
			}
		},
		watch: {

		},
		created() {
			this.parkId = this.$route.query.parkId
			this.gardenId = this.$route.query.gardenId
		},
		mounted() {
			const that = this
			that.getRecordData()
			that.getErrorRecordData()
			that.getCarGate()
			that.timer = setInterval(function () {
				that.getRecordData()
				that.getErrorRecordData()
			}, 30000)
		},
		methods: {
			// ID序号功能
			indexMethod(index) {
				return index + 1
			},
			// 获取记录数据
			getRecordData() {
				this.$get(`carInOutAll?&pageNo=1&pageSize=10&gardenId=${this.gardenId}&parkId=${this.parkId}`)
					.then(res => {
							console.log(res)
							if (res && res.errCode === 0) {
								this.recordData = res.list
							}
						},
						err => {
							this.$message.error(err)
						})
			},
			// 获取错误日志数据
			getErrorRecordData() {
				let loading = this.$loading()
				this.$get(
					`/carRecord?&gardenId=${this.gardenId}&parkId=${this.parkId}&isError=1&cameraNum=&carNum=&preHouseholdNameOrPhone=&parkingNumber=&createTimeSt=&createTimeEn=&pageNo=1&pageSize=10`
				).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							console.log(res)
							this.errorRecordData = res.list
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			// 获取弹窗出入口数据
			getCarGate() {
				this.$get(`carGate?&pageNo=1&pageSize=99&parkId=${this.parkId}`)
					.then(res => {
							console.log(res)
							if (res && res.errCode === 0) {
								this.carGateData = res.list
							}
						},
						err => {
							this.$message.error(err)
						})
			},
			// 关闭弹窗
			hideDialog() {
				this.dialogVisible = false
				this.form.carNum = ''
				this.form.gateId = ''
				this.form.remark = ''
			},
			// 人工入场
			peopleIn() {
				this.inOut = 1
				this.form.carNum = ''
				this.form.gateId = ''
				this.form.remark = ''
				this.dialogVisible = true
			},
			// 人工出场
			peopleOut() {
				this.inOut = 2
				this.form.carNum = ''
				this.form.gateId = ''
				this.form.remark = ''
				this.dialogVisible = true
			},
			// 人工入场出场确定
			onSubmit(form) {
				this.$refs.form.validate((valid) => {
					if (valid) {
						var loading = this.$loading()
						if (this.inOut == 1) {
							this.$get(
									`carInByHand?gardenId=${this.gardenId}&parkId=${this.parkId}&gateId=${this.form.gateId}&carNum=${this.form.carNum}&remark=${this.form.remark}`
								)
								.then(res => {
										loading.close()
										if (res && res.errCode === 0) {
											this.$message({
												type: 'success',
												message: this.$i18n.t('lang.lab_peoInSuccess')
											})
											this.form.carNum = ''
											this.form.gateId = ''
											this.form.remark = ''
											this.dialogVisible = false
										} else {
											this.$message({
												type: 'success',
												message: res.errMsg
											})
										}
									},
									err => {
										loading.close()
										this.$message.error(err)
									})
						} else if (this.inOut == 2) {
							this.$get(
									`carOutByHand?gardenId=${this.gardenId}&parkId=${this.parkId}&gateId=${this.form.gateId}&carNum=${this.form.carNum}&remark=${this.form.remark}`
								)
								.then(res => {
										loading.close()
										console.log(res)
										if (res && res.errCode === 0) {
											this.$message({
												type: 'success',
												message: this.$i18n.t('lang.lab_peoOutSuccess')
											})
											this.form.carNum = ''
											this.form.gateId = ''
											this.form.remark = ''
											this.dialogVisible = false
										} else {
											this.$message({
												type: 'success',
												message: res.errMsg
											})
										}
									},
									err => {
										console.log(err)
										loading.close()
										this.$message.error(err)
									})
						}
					} else {
						console.log('error submit!!')
						return false
					}
				})
			},
			onSdkz(form) {
				this.form.carNum = '云A12345'
			},
			onSscph(form) {
				let gateId = this.form.gateId
				if (gateId == null || gateId == '') {
					this.$message.error('请选择出入口')	
				} else {
					let loading = this.$loading()
					this.$get(
						`/carRecordNew?parkId=${this.parkId}&gateType=${this.inOut}&gateId=` + gateId
					).then(
						res => {
							loading.close()
							if (res && res.errCode === 0) {
								console.log(res)
								this.form.carNum = res.carNum
							}
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
				}
			},
			// 查看图片
			seePhoto(url) {
				this.dialogVisible1 = true
				this.imgUrl = url
				let arr = []
				arr.push(url)
				this.imgUrlList = arr
			},
		},
		beforeDestroy() {
			clearInterval(this.timer)
		},
		destroyed() {

		},
	}
</script>

<style lang="scss">
	.p-0 {
		padding: 10px;
	}

	.box {
		display: flex;
		margin-top: 20px;
	}

	.card {
		flex: 1
	}

	.carIn,
	.carOut {
		width: 250px;
		text-align: center;
		position: relative;
	}

	.cardImg {
		width: 150px;
		position: absolute;
		left: 50%;
		top: 50%;
		margin-top: -75px;
		margin-left: -75px;
	}

	.bottomBox .recordTable {
		// width: 100% !important;
		height: 32vh !important;
		margin-top: 20px;
		overflow: auto !important;
	}

	.recordTable .el-table {
		min-width: 100%;
		overflow: auto;
	}
</style>